var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select-filter',{attrs:{"label":"Empresa","options":_vm.listaEmpresas},model:{value:(_vm.comboEmpresaSelecionada),callback:function ($$v) {_vm.comboEmpresaSelecionada=$$v},expression:"comboEmpresaSelecionada"}})}
var staticRenderFns = []

export { render, staticRenderFns }